
import { defineComponent } from "vue";
import Modal from "../Components/Modal.vue";
import gameApplication from "../../game/game-app";

export default defineComponent({
  name: "HelpModal",

  methods: {
    onOkay(): void {
      if (gameApplication.getInGame()  === true || gameApplication.getGameKind() == 'PRACTICE') {
        gameApplication.getBillardGame().stick.active = true;
      }
      
      this.$emit('close');
    },
  },

  components: { Modal },
});
